import * as yup from 'yup'
import messages from './messages'

export const getRoleValidationSchema = (formatMessage: any) =>
  yup.object({
    name: yup.string().required(formatMessage(messages.nameIsRequired)),
    description: yup.string().required(formatMessage(messages.descriptionIsRequired)),
  })
